/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskBoxPersonResponse } from './TaskBoxPersonResponse';
import {
    TaskBoxPersonResponseFromJSON,
    TaskBoxPersonResponseFromJSONTyped,
    TaskBoxPersonResponseToJSON,
    TaskBoxPersonResponseToJSONTyped,
} from './TaskBoxPersonResponse';

/**
 * 
 * @export
 * @interface TaskBoxesParticipantsResponse
 */
export interface TaskBoxesParticipantsResponse {
    /**
     * 
     * @type {string}
     * @memberof TaskBoxesParticipantsResponse
     */
    taskBoxId?: string;
    /**
     * 
     * @type {TaskBoxPersonResponse}
     * @memberof TaskBoxesParticipantsResponse
     */
    pwrTaskBoxCreator?: TaskBoxPersonResponse;
    /**
     * 
     * @type {Array<TaskBoxPersonResponse>}
     * @memberof TaskBoxesParticipantsResponse
     */
    pwrParticipants?: Array<TaskBoxPersonResponse>;
}

/**
 * Check if a given object implements the TaskBoxesParticipantsResponse interface.
 */
export function instanceOfTaskBoxesParticipantsResponse(value: object): value is TaskBoxesParticipantsResponse {
    return true;
}

export function TaskBoxesParticipantsResponseFromJSON(json: any): TaskBoxesParticipantsResponse {
    return TaskBoxesParticipantsResponseFromJSONTyped(json, false);
}

export function TaskBoxesParticipantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskBoxesParticipantsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'taskBoxId': json['taskBoxId'] == null ? undefined : json['taskBoxId'],
        'pwrTaskBoxCreator': json['pwrTaskBoxCreator'] == null ? undefined : TaskBoxPersonResponseFromJSON(json['pwrTaskBoxCreator']),
        'pwrParticipants': json['pwrParticipants'] == null ? undefined : ((json['pwrParticipants'] as Array<any>).map(TaskBoxPersonResponseFromJSON)),
    };
}

export function TaskBoxesParticipantsResponseToJSON(json: any): TaskBoxesParticipantsResponse {
    return TaskBoxesParticipantsResponseToJSONTyped(json, false);
}

export function TaskBoxesParticipantsResponseToJSONTyped(value?: TaskBoxesParticipantsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskBoxId': value['taskBoxId'],
        'pwrTaskBoxCreator': TaskBoxPersonResponseToJSON(value['pwrTaskBoxCreator']),
        'pwrParticipants': value['pwrParticipants'] == null ? undefined : ((value['pwrParticipants'] as Array<any>).map(TaskBoxPersonResponseToJSON)),
    };
}

